import React from "react";
import DateWiseStreak from "./DateWiseStreak";
import TopUsersGlobal from "./TopUsersGlobal";
import TopUsersCityWise from "./TopUsersCityWise";

const Leaderboard = () => {
  return (
    <div>
      <DateWiseStreak />
      <TopUsersGlobal />
      <TopUsersCityWise />
    </div>
  );
};

export default Leaderboard;
